import Transform from "@ember-data/serializer/transform";
import Vaccine from "parog-web/models/vaccine";

interface SerializedVaccine {
  name: string;
  done?: boolean;
  vaccinationDate?: string;
}

export default class VaccinesTransform extends Transform {
  override deserialize(
    serialized: SerializedVaccine[] | null
  ): Vaccine[] | null {
    if (!(serialized instanceof Array)) return null;

    return serialized.map(r => {
      const vaccinationDate = r.vaccinationDate
        ? new Date(r.vaccinationDate)
        : undefined;
      return new Vaccine(r.name, r.done, vaccinationDate);
    });
  }

  override serialize(
    deserialized: Vaccine[] | null
  ): SerializedVaccine[] | null {
    if (deserialized == null) return null;

    return deserialized.map(r => r.serialize());
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    vaccines: VaccinesTransform;
  }
}
